@if (oldBillingDesign) {
  <div class="main row">
    <div>
      <alerts-bar alertSelector="getHomesitePoliciesAlert"></alerts-bar>

      @if (!billingDashboardEnabled) {
        <ds-bill-account-manage></ds-bill-account-manage>
      }
      @if (billingDashboardEnabled) {
        <ds-billing-dashboard-wrapper></ds-billing-dashboard-wrapper>
      }

      <section id="billing-details" class="margin-bottom-20">
        @if ((pendingPayments$ | async)?.length) {
          <div class="block margin-bottom-30">
            <ds-bill-account-get-started
              [pendingPayments]="pendingPayments$ | async"
              [billacountsEligibleForAutoPay$]="billacountsEligibleForAutoPay$"
              [pendingRegistrations]="pendingRegistrations$ | async"
              [hasPastDue]="hasPastDue$ | async"
              (silentRegistrationFailureEvent)="silentRegistrationFailure($event)"
            ></ds-bill-account-get-started>
          </div>
        }
        @if (silentRegistrationError) {
          <ds-error-message [errorList]="errorList"></ds-error-message>
        }
        <ds-bill-account-add></ds-bill-account-add>

        @if (billAccountsData?.length) {
          <div class="row margin-top-40">
            <div class="column twelve">
              <ds-accordion
                [allowMultipleOpenCategories]="true"
                [allowToggleAccordion]="true"
                (expandAllEvent)="expandAllClicked()"
              >
                @if (
                  (billacountsEligibleForAutoPay$ | async)?.length > 0 ||
                  (billacountsHasAutoPay$ | async)?.length > 0 ||
                  (billacountsELigibleAutoPay$ | async)?.length > 0
                ) {
                  <ds-accordion-category
                    [title]="manageAutoPay"
                    (opening)="toggleAccordion('autopayAccordion', $event)"
                    (closing)="toggleAccordion('autopayAccordion', $event)"
                    [dsAnalyticsClick]="autoPayAccordionAnalytic.link"
                    data-cy="manageAutopayAccordion"
                  >
                    <div class="accordion-content-wrapper">
                      <ds-auto-pay-detail-wrapper
                        data-cy="setupAutopayAccordion"
                      ></ds-auto-pay-detail-wrapper>
                    </div>
                  </ds-accordion-category>
                }
                @if (showPaymentsOrMethodsAccordion) {
                  <ds-accordion-category
                    [title]="myPaymentMethods"
                    (opening)="toggleAccordion('methodsAccordion', $event)"
                    (closing)="toggleAccordion('methodsAccordion', $event)"
                    [startOpen]="accordionStatus.methodsAccordion"
                    data-cy="billAccountSectionAccordionManagePaymentMethods"
                  >
                    <div class="accordion-content-wrapper">
                      <p dsContent [contentPath]="'billing.managePaymentsAdvancedCustomerTxt'"></p>
                      <ds-payment-methods></ds-payment-methods>
                    </div>
                  </ds-accordion-category>
                }
                @if (showPaymentsOrMethodsAccordion) {
                  <ds-accordion-category
                    [title]="manageOneTimePayments"
                    (opening)="toggleAccordion('paymentsAccordion', $event)"
                    (closing)="toggleAccordion('paymentsAccordion', $event)"
                    [dsAnalyticsClick]="scheduledPaymentAccordionAnalytic.link"
                    data-cy="manageScheduledPaymentsAccordion"
                  >
                    <div class="accordion-content-wrapper">
                      <ds-bill-account-payments-scheduled
                        data-cy="scheduledPaymentWrapper"
                        class="block pad-bottom-20"
                      ></ds-bill-account-payments-scheduled>
                    </div>
                  </ds-accordion-category>
                }
                @if (billAccountsData?.length) {
                  <ds-accordion-category
                    id="{{ paymentHistoryElementIdConst }}"
                    [title]="paymentHistory"
                    (opening)="toggleAccordion('paymentHistoryAccordion', $event)"
                    (closing)="toggleAccordion('paymentHistoryAccordion', $event)"
                    data-cy="billAccountSectionAccordionManagePaymentHistory"
                  >
                    <div class="accordion-content-wrapper">
                      <ds-payment-history
                        [accordionIsOpen]="accordionStatus.paymentHistoryAccordion"
                      ></ds-payment-history>
                    </div>
                  </ds-accordion-category>
                }
                @if (billAccountsData?.length) {
                  <ds-accordion-category
                    [title]="statementHistory"
                    (opening)="toggleAccordion('billingHistoryAccordion', $event)"
                    (closing)="toggleAccordion('billingHistoryAccordion', $event)"
                  >
                    <div class="accordion-content-wrapper">
                      <ds-bill-account-statement-history></ds-bill-account-statement-history>
                    </div>
                  </ds-accordion-category>
                }
              </ds-accordion>
            </div>
          </div>
        }
      </section>
    </div>
  </div>
}
@if (newBillingDesign) {
  <div class="main row main-background">
    <alerts-bar alertSelector="getHomesitePoliciesAlert"></alerts-bar>
    <div class="billing-overview-header font-weight-bold font-size-2">
      {{ billingTitlesCopy.mainHead }}
    </div>
    <overview-billing-wrapper [navFromBillDash]="true"></overview-billing-wrapper>
    <div class="row column twelve">
      <div class="column twelve md-four pad-right-16 payment-tool-container">
        <div class="billing-overview-sub-head">{{ billingTitlesCopy.subHead1 }}</div>
        <div class="billing-accodion-container">
          @if (
            (billacountsEligibleForAutoPay$ | async)?.length > 0 ||
            (billacountsHasAutoPay$ | async)?.length > 0 ||
            (billacountsELigibleAutoPay$ | async)?.length > 0
          ) {
            <ds-accordion-category
              [title]="manageAutoPay"
              [dsAnalyticsClick]="autoPayAccordionAnalytic.link"
              titleIcon="autopay.svg"
              data-cy="manageAutopayAccordion"
              (click)="redirectToManageAutopay()"
            >
            </ds-accordion-category>
          }
          @if (showPaymentsOrMethodsAccordion) {
            <ds-accordion-category
              [title]="paymentMethods"
              [startOpen]="accordionStatus.methodsAccordion"
              data-cy="billAccountSectionAccordionManagePaymentMethods"
              titleIcon="icon-wallet.svg"
              aria-readonly="true"
              (click)="redirectToPaymentMethod()"
            >
            </ds-accordion-category>
          }
          @if (showPaymentsOrMethodsAccordion) {
            <ds-accordion-category
              [title]="payBills"
              [dsAnalyticsClick]="payBillsAccordionAnalytic.link"
              data-cy="manageScheduledPaymentsAccordion"
              titleIcon="online-payment.svg"
              aria-readonly="true"
              (click)="redirectToPayment()"
            >
            </ds-accordion-category>
          }
        </div>
        <div class="link-account row column twelve">
          <ds-bill-account-add [newBillingDesign]="true"></ds-bill-account-add>
        </div>
      </div>
      <div class="column twelve md-eight" id="paymentHistory" isRendered (iAmReady)="goToSection()">
        <div class="billing-overview-sub-head">{{ billingTitlesCopy.subHead2 }}</div>
        <div class="history-container margin-bottom-30">
          <div class="navbar row">
            <div
              class="column six text-center nav-section"
              [class.active-section]="selectedSection === 'payment'"
              (click)="selectSection('payment')"
            >
              <span>{{ billingTitlesCopy.historySubTitle1 }}</span>
            </div>
            <div
              class="column six text-center nav-section"
              [class.active-section]="selectedSection === 'statement'"
              (click)="selectSection('statement')"
            >
              <span>{{ billingTitlesCopy.historySubTitle2 }}</span>
            </div>
          </div>
          @if (selectedSection === 'payment') {
            <div>
              <ds-new-payment-history [navigation]="navigation"></ds-new-payment-history>
            </div>
          }
          @if (selectedSection === 'statement') {
            <div>
              <ds-bill-account-statement-history
                [newBillingDesign]="true"
              ></ds-bill-account-statement-history>
            </div>
          }
        </div>
      </div>
    </div>
  </div>
}
